import { Icon, IconID, IconColor, IconSize } from 'packages/radiant-react/icon';
import { Horizontal, Vertical } from 'packages/radiant-react/layout';
import { Typography, Colors } from 'packages/radiant-react/typography';
import styles from './styles.module.scss';

export const NoObjectSelected = ({
  title,
  description,
}: {
  title: string;
  description: string;
}) => {
  return (
    <Vertical className={styles.emptyEmbed} role="region" aria-label="Object selection required">
      <Horizontal className={styles.liveboardEmbedContent}>
        <Icon
          id={'magnifying-glass' as IconID}
          color={IconColor.WHITE}
          size={IconSize.XXLARGE}
          className={styles.liveboardEmbedIcon}
          aria-label="Search icon"
        />
        <Vertical>
          <Typography
            variant="p-bold"
            color={Colors.grayLight}
            className={styles.liveboardEmbedTitle}
            role="heading"
            aria-level={2}
          >
            {title}
          </Typography>
          <Typography
            variant="p"
            color={Colors.grayLight}
            className={styles.liveboardEmbedDescription}
          >
            {description}
          </Typography>
        </Vertical>
      </Horizontal>
    </Vertical>
  );
};
